import { button } from "framer-motion/client";
import Button from "../Button/Button";
import Typography from "../Typography/Typography";
import { CircleFadingArrowUp, Cog, Library } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../store/AuthContext/AuthContext";
import { useEffect, useState } from "react";

export default function AppHeader(props) {
  const { onUpgradeClick } = props;
  const navigate = useNavigate();
  const { isSubbed } = useAuth();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isSubbed === true) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  }, [isSubbed]);

  const handleLibraryNavigate = () => {
    navigate("/client/library");
  };

  const handleSettingsNavigate = () => {
    navigate("/client/settings");
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div className="z-50 w-full flex justify-between items-center p-4 py-6 bg-gray-100 border-b-2 border-gray-150">
      <Typography size="16" weight="md">
        {props.text}
      </Typography>
      <div className="flex flex-row gap-3">
        {isMobile && (
          <Button
            size="lg"
            type="bw"
            onClick={handleSettingsNavigate}
            icon={<Cog size={16} />}
          />
        )}
        {isVisible && (
          <Button
            licon={<CircleFadingArrowUp size={16} />}
            size="sm"
            type="color"
            text="Upgrade"
            onClick={onUpgradeClick}
          />
        )}
        {/* {window.location.href.includes("research") && (
          <Button
            size="sm"
            text="Library"
            type="bw"
            onClick={handleLibraryNavigate}
            licon={<Library size={16} />}
          />
        )} */}
      </div>
    </div>
  );
}
